import React from 'react';
import NewLayout from '../layout/newLayout';
import NewArticle from '../components/newArticle';
import CtaBanner from "../components/ctaBanner";
import Title from "../components/title";
import SEO from "../components/seo";
import { slice as _slice, map as _map, uniqBy as _uniqBy, flatten as _flatten } from 'lodash';
import styles from '../styles/scss/pages/blog.module.scss';
import InfiniteScroll from 'react-infinite-scroll-component';
import EventAnchor from '../components/eventAnchor';
import SelectMany from '../components/selectMany';
import DropdownContent from '../components/dropdownContent';

const pageSize = 9;

const filterBlogs = function filterBlogs(blogs, selectedTags) {
    const out = blogs.filter(blog => {
        let matchCategory = true;
        
        if (selectedTags && selectedTags.length > 0) {
            matchCategory = blog.filterKeywords && blog.filterKeywords.some(keyword => selectedTags.includes(keyword));
        }
        
        return matchCategory;
    });
    return out;
};

const NewBlogTemplate = ({
    pageContext
}) => {

    // States
    const [currentPage, setCurrentPage] = React.useState(0);
    const [selectedTags, setSelectedTags] = React.useState([]);
    const [blogs] = React.useState(() => {
        return pageContext.blogs.sort((a, b) => {
            return a.dateOfArticle < b.dateOfArticle ? 1 : -1
        });
    });

    const allTags = React.useMemo(() => {
        const keywordsArray = _flatten(_map(blogs, 'filterKeywords').filter(Boolean));
        return _uniqBy(keywordsArray.map(keyword => ({ value: keyword, text: keyword })), 'value');
    }, [blogs]);

    const visibleTags = React.useMemo(() => {
        return allTags
    }, [allTags]);

    const handleTagChange = React.useCallback((selected) => {
        setSelectedTags(selected);
        setCurrentPage(0);
    }, []);

    const handleClearFilters = React.useCallback(() => {
        setSelectedTags([]);
        setCurrentPage(0);
    }, []);

    const handleInfiniteScrollNext = React.useCallback(() => {
        setCurrentPage(s => s + 1);
    }, []);

    // Memos
    const {
        pagedBlogs,
        pages
    } = React.useMemo(() => {
        const out = {
            pagedBlogs: [],
            pages: 0
        };

        if (blogs && blogs.length) {
            // Filter blogs
            const filteredBlogs = filterBlogs(blogs, selectedTags);

            // Paginate blogs
            const paginationStart = currentPage * pageSize;
            const paginationEnd = (currentPage * pageSize) + pageSize;
            const newpagedBlogs = _slice(filteredBlogs, paginationStart, paginationEnd);
            const previouspagedBlogs = _slice(filteredBlogs, 0, paginationStart);

            out.pagedBlogs = currentPage === 0 ? newpagedBlogs : [...previouspagedBlogs, ...newpagedBlogs];

            // Calculate Pages based on filtered blogs
            out.pages = Math.ceil(filteredBlogs.length / pageSize);
        }

        return out;
    }, [
        currentPage,
        blogs,
        selectedTags,
    ]);

    // Disable SSR on this page
    if (typeof window === 'undefined') {
        return null;
    }

    return (
        <NewLayout>
            <h1 style={{ display: 'none' }}>{(pageContext.page && pageContext.page.seo && pageContext.page.seo.title) || 'WD-40 Brand Blog'}</h1>
            <SEO page={pageContext.page} />
            <div className='d-flex flex-column flex-fill'>

                <InfiniteScroll
                    className={styles.infiniteContainer}
                    dataLength={pagedBlogs.length}
                    hasMore={currentPage <= (pages - 1)}
                    loader={() => (
                        <h4>
                            Loading...
                        </h4>
                    )}
                    endMessage={
                        <p className={styles.endMessage}>
                            There are no more blogs
                        </p>
                    }
                >

                    <div className={styles.topContentWrapper}>
                        <div
                            className={styles.topContent}
                        >
                            <Title
                                className={styles.sitetitleNewLayout}
                                value="WD-40® Brand Blog"
                            />

                        </div>
                        {allTags.length > 0 && (
                            <div className={styles.filterContainer}>
                                <DropdownContent title="Filter by" className='noPadding'>
                                    <div className={styles.tagsScrollable}>
                                        <SelectMany 
                                            name='Filter' 
                                            values={visibleTags} 
                                            selected={selectedTags} 
                                            onChange={handleTagChange} 
                                            xxl={4} 
                                            xl={4} 
                                        />
                                    </div>
                                    <div className={styles.filterActions}>
                                        <EventAnchor 
                                            event={handleClearFilters} 
                                            text="Clear all filters >>" 
                                            condensed 
                                        />
                                    </div>
                                </DropdownContent>
                            </div>
                        )}
                    </div>

                    <div className={styles.container}>
                        <div className={styles.items}>
                            {pagedBlogs.length > 0 && pagedBlogs.map(blog => (
                                <div key={blog.id} className={styles.blogItem}>
                                    <NewArticle
                                        article={blog}
                                        imageClass={styles.itemImage}
                                        bodyClass={styles.itemBody}
                                    />
                                </div>
                            ))}
                            {currentPage < (pages - 1) &&
                                <div className={styles.seeMoreAnchor}>
                                    <EventAnchor
                                        text="See more blog posts >>"
                                        event={handleInfiniteScrollNext}
                                        condensed
                                    />
                                </div>
                            }
                        </div>
                    </div>
                </InfiniteScroll>

            </div>

            <CtaBanner
                text="WANT TO GET MORE TIPS AND TRICKS?"
                buttonText="SUBSCRIBE TO THE NEWSLETTER"
                buttonUrl="/signup/"
            />
        </NewLayout>
    )
}

export default React.memo(NewBlogTemplate);